import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrawer4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDrawer4"><Path fillRule="evenodd" clipRule="evenodd" d="M11.25 4H2V17H4.25L4.25 19.75H5.75L5.75 17H11.25V4ZM9.5 8H8V12H9.5V8Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M12.75 17H18.25V19.75H19.75V17H22V4H12.75V17ZM16 8V12H14.5V8H16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDrawer4;
